import { AppSettings } from '../../types';
import { seedAllMockData } from '../../utils/seedData';

export function useDashboardActions(
  refetchProfiles: () => Promise<any>,
  updateSettings: (settings: Partial<AppSettings>) => Promise<any>
) {
  
  const handleSaveSettings = async (newSettings: AppSettings) => {
    try {
      await updateSettings(newSettings);
    } catch (error) {
      console.error('Failed to save settings:', error);
    }
  };

  const handleSeedData = async () => {
    const success = await seedAllMockData();
    if (success) {
      alert('Data seeded! Refreshing...');
      refetchProfiles();
    } else {
      alert('Failed to seed data.');
    }
  };

  return {
    saveSettings: handleSaveSettings,
    seedData: handleSeedData
  };
}












